import EarthMobile from './EarthMobile'

export default EarthMobile
